import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { DocumentReject, PendingVerificationImage } from '@images';

import ContactSupport from '@components/contact-support/ContactSupport';
import { OrgStatus } from '@constants/generic';
import {
  Event,
  sendMixpanelEvent,
  trackPageView
} from '@core/analytics/mixpanel';
import Modal from '@layouts/modal/Modal';

import AccountReadinessTimeline from './AccountReadinessTimeline';

const PendingVerification = () => {
  const { currentOrg } = useSelector((state: any) => state.user);

  const orgStatus = currentOrg?.status;

  const [isSupportModalOpen, setIsSupportModalOpen] = useState(false);

  const onClickContactSupport = () => {
    setIsSupportModalOpen(true);
    sendMixpanelEvent(Event.CONTACT_SUPPORT_CLICKED, {
      organization_name: currentOrg.name
    });
  };

  useEffect(() => {
    if (currentOrg?.id)
      trackPageView('Pending Verification', {
        organization_name: currentOrg.name
      });
  }, [currentOrg]);

  return (
    <div className="flex size-full flex-col items-center justify-between rounded-3xl bg-cofeeNeutral1">
      <div className="my-12 flex w-full flex-col items-center justify-center">
        <div className="flex flex-col items-center">
          {orgStatus === OrgStatus.REJECTED ? (
            <DocumentReject className="h-63 w-57.25" />
          ) : (
            <PendingVerificationImage className="h-63 w-57.25" />
          )}
          <div className="flex flex-col items-center gap-4">
            <span className="text-2xl font-semibold text-cofeeNeutral13">
              {orgStatus === OrgStatus.REJECTED
                ? 'Oops! Issue with uploaded documents.'
                : 'Your account is almost ready !'}
            </span>
            <AccountReadinessTimeline
              selfDeclarationStatus={currentOrg?.declaration_status || ''}
              orgStatus={orgStatus as OrgStatus}
              orgId={currentOrg?.id || ''}
            />
          </div>
        </div>
      </div>
      <div className="mb-8 flex flex-col items-center">
        <div className="flex flex-col items-center text-sm font-medium leading-4 text-grey">
          Need help?
          <div className="mb-2 mt-3 font-normal">Talk to our support team</div>
        </div>
        <div
          className="cursor-pointer text-base font-medium text-primary underline"
          onClick={onClickContactSupport}
          role="presentation"
        >
          Contact support
        </div>
      </div>
      {isSupportModalOpen && (
        <Modal
          isOpen={isSupportModalOpen}
          onCancel={() => setIsSupportModalOpen(false)}
          isCloseIconRequired
          className="min-w-325  p-6 "
        >
          <ContactSupport />
        </Modal>
      )}
    </div>
  );
};

export default PendingVerification;
